<template>
  <div class="container">
    <!--begin::Row-->
    <div class="row">
      <div class="col-12">
        <!--begin::Advance Table Widget 3-->
        <div class="card card-custom card-stretch gutter-b">
          <!--begin::Header-->
          <div class="card-header border-0 py-5 row">
            <div class="card-toolbar flex-grow-1">
                <div class="col-12 col-md-4">
                    <b-input-group>
                      <b-form-input
                        v-model="filters.date"
                        name="date"
                        type="text"
                        autocomplete="off"
                        v-mask="'####-##-##'"
                        class="form-control form-control-solid h-auto py-3 px-3"
                        placeholder="YYYY-MM-DD"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-form-datepicker
                          :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                          v-model="filters.date"
                          name="date"
                          button-only
                          right
                          locale="en-US"
                          class="button-only-datepicker"
                        ></b-form-datepicker>
                      </b-input-group-append>
                    </b-input-group>
                </div>
                <div class="col-12 col-md-8 text-right">
                  <button 
                  class="btn btn-light-primary m-1 px-10"
                  @click="showExportModal()"
                  >
                      Export
                  </button>
                </div>
            </div>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body pt-0 pb-3">
            <!--begin::Table-->
            <div class="table-responsive">
              <table
                class="table table-head-custom table-head-bg table-borderless table-vertical-center table-hover"
              >
                <thead>
                  <tr class="text-uppercase">
                    <th class="pl-7" style="min-width: 150px">
                      <span class="text-dark-75">DATE &amp; TIME</span>
                      <!-- <button class="sort-button" @click="sortItems"><i class="flaticon2-sort text-dark"></i></button> -->
                    </th>
                    <th style="min-width: 150px">IP ADDRESS</th>
                    <th style="min-width: 100px">USERNAME</th>
                    <th style="min-width: 150px">ACTION</th>
                    <th style="min-width: 150px">DETAILS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in items" :key="index+'_'+item.RequestTimestamp">
                    <td class="py-2">
                      <div class="d-flex align-items-center">
                        <div>
                            <a
                              class="text-primary font-weight-bolder text-hover-secondary mb-1 font-size-lg"
                              :href="item.exportLink"
                              target="_blank"
                              >{{ item.RequestTimestamp }}</a
                            >
                        </div>
                      </div>
                    </td>
                    <td>
                      <span class="text-muted d-block">{{
                        item.ClientIP
                      }}</span>
                    </td>
                    <td>
                      <span class="text-muted d-block">{{
                        item.UserName
                      }}</span>
                    </td>
                    <td>
                      <span class="text-muted d-block">{{
                        item.Activity
                      }}</span>
                    </td>
                    <td class=" pr-0">
                      <span class="text-muted">{{
                        item.Details
                      }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!--end::Table-->
          </div>
          <!--end::Body-->
        </div>
        <!--end::Advance Table Widget 3-->
      </div>
    </div>
    <!--end::Row-->
    
    <!--begin::Pagination-->
    <div class="card card-custom">
      <div class="card-body pt-0 pb-2">
        <Paginator
            v-bind:currentPage="filters.currentPage"
            v-bind:rowsPerPage="filters.rowsPerPage"
            v-bind:totalRows="totalRows"
            @update-currentpage="
              value => {
                filters.currentPage = value;
                this.getData();
              }
            "
            @update-pagesize="
              value => {
                filters.currentPage = 1;
                setPageSize(value);
              }
            "
          />
      </div>
    </div>
    <!--end::Pagination-->

    <!-- Export Modal -->
    <b-modal ref="export-modal" size="lg" hide-footer hide-header>
      <div class="d-block text-left">
        <h3>Export Audit Log</h3>
      </div>
      <div class="row py-5">
        <div class="col-12 col-md-4">
          <b-form-group
              label="From"
              label-for="from"
            >
            <b-input-group>
              <b-form-input
                v-model="form.from"
                :state="validateState('from')"
                name="from"
                type="text"
                autocomplete="off"
                v-mask="'####-##-##'"
                class="form-control form-control-solid h-auto py-3 px-3"
                placeholder="YYYY-MM-DD"
              ></b-form-input>
              <b-input-group-append>
                <b-form-datepicker
                  :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                  v-model="form.from"
                  name="date"
                  button-only
                  right
                  locale="en-US"
                  class="button-only-datepicker"
                ></b-form-datepicker>
              </b-input-group-append>
              <b-form-invalid-feedback>
                Date From is required.
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </div>
        <div class="col-12 col-md-4">
          <b-form-group
              label="To"
              label-for="to"
            >
            <b-input-group>
              <b-form-input
                v-model="form.to"
                :state="validateState('to')"
                name="to"
                type="text"
                autocomplete="off"
                v-mask="'####-##-##'"
                class="form-control form-control-solid h-auto py-3 px-3"
                placeholder="YYYY-MM-DD"
              ></b-form-input>
              <b-input-group-append>
                <b-form-datepicker
                  :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                  v-model="form.to"
                  name="to"
                  button-only
                  right
                  locale="en-US"
                  class="button-only-datepicker"
                ></b-form-datepicker>
              </b-input-group-append>
              <b-form-invalid-feedback>
                Date To is required and must be greater than or equal to Date From. Maximum of 7 days range.
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </div>
        <div class="col-12 col-md-4">
          <b-form-group
              label="Username"
              label-for="username"
            >
            <b-input-group>
              <b-form-input
                v-model="form.username"
                name="username"
                type="text"
                autocomplete="off"
                class="form-control form-control-solid h-auto py-3 px-3"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-right">
          <b-button class="mr-4" variant="light-primary" @click="$refs['export-modal'].hide()">Cancel</b-button>
          <b-button
            variant="primary"
            @click="exportLog()"
            :disabled="this.isBusy || $v.$invalid || !$v.$anyDirty"
            >Export</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<style scoped>

td {
    max-width: 300px;
    min-width: 150px;
    word-wrap: break-word;
}
</style>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ApiService from "@/view/pages/easyreceipt/api";
import Vue from "vue";
import { mask } from "vue-the-mask";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import Paginator from "@/view/content/widgets/paginator"

Vue.use(require("vue-moment"));
export default {
  mixins: [validationMixin],
  components: { Paginator },
  directives: { mask },
  data() {
    return {
      isBusy: false,
      filters: {
        date: "",
        currentPage: 1,
        rowsPerPage: 50
      },
      form : {
        from : "",
        to : "",
        username : ""
      },
      options: {
        Status: [],
        RDOs: []
      },
      items: [],
      totalRows : 0
    };
  },
  validations: {
    form: {
      from: { required },
      to: { 
        required,
        minValue(val, { from }) {
          return new Date(val) >= new Date(from);
        },
        maxValue(val, { from }) {
          let day_from = new Date(from); 
          var day_to= new Date(val);
          var difference= Math.abs(day_to-day_from);
          let days = difference/(1000 * 3600 * 24)
          return days <= 7;
        }
      },
      username: { }
    }
  },
  computed: {
    ...mapGetters(["layoutConfig", "currentUser", "currentUserRoles"]),
    config() {
      return this.layoutConfig();
    },
    filters_ocn() {
      return this.filters.OCN;
    },
    hasSuperAdmin: function() {
      return this.hasRole("atg:superadmin");
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "List",
        route: "/users/list"
      },
      { title: "Users" }
    ]);
    this.init();
  },
  methods: {
    init() {
      var today = new Date().toISOString().slice(0, 10);
      this.filters.date = today;
      this.resetForm();
    },
    hasRole: function(roleName) {
      let retVal = false;
      if (this.currentUserRoles)
        retVal = this.currentUserRoles.indexOf(roleName) !== -1;
      return retVal;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    showExportModal() {
      this.$refs['export-modal'].show();
      this.resetForm();
    },
    resetForm() {
      this.form = {
        from : "",
        to : "",
        username : ""
      };

      this.$nextTick(() => {
        this.$v.$reset();
        this.$v.form.$touch();
      });
    },
    async getData() {
      var self = this;
      self.isBusy = true;
      try {
        let param = {
          Date: this.filters.date,
          CurrentPage: this.filters.currentPage,
          RowsPerPage: this.filters.rowsPerPage
        };
        const response = await ApiService.post("audit/search", param);
        const data = response.data;
        this.$gtag.event("audit_search", param);
        data.Items.filter(item => {
          let date_param = new Date(item.RequestTimestamp).toISOString().slice(0, 10);
          item.exportLink = `${ApiService.baseUrl}audit/export?StartDate=${date_param}&EndDate=${date_param}&Username=${item.RequestUserName}&access_token=${ApiService.getToken()}`;
          return item;
        });
        //console.log("response=>", data);
        self.items = data.Items;
        self.totalRows = data.TotalRows;
        self.isBusy = false;
        window.scrollTo(0, 0);
      } catch(err) {
        self.items = [];
        self.isBusy = false;
        window.scrollTo(0, 0);
      }
    },
    setPageSize(pageSize){
      this.filters.rowsPerPage = pageSize;
      this.getData();
    },
    exportLog(){
      this.$refs['export-modal'].hide();
      let url = `${ApiService.baseUrl}audit/export?StartDate=${this.form.from}&EndDate=${this.form.to}&Username=${this.form.username}&access_token=${ApiService.getToken()}`;
      window.open(url, '_blank').focus();
    }
  },
  watch: {
    "filters.date" : function(newValue, oldValue) {
      if (newValue != oldValue) {
        this.getData();
      }
    }
  }
};
</script>
